import React, {
    useEffect,
    useRef,
    useState
} from "react";

import {
    ArrowLeftOutlined,
    CompressOutlined,
    ExpandOutlined,
    ReloadOutlined
} from "@ant-design/icons";

import {
    useNavigate
} from "react-router-dom";

import {
    renderAsync
} from "docx-preview";

import {
    getDocxReaderBuffer
} from "../api/myBook";


export default function DocxLabView({
    slug,
    title
}) {

    const navigate =
        useNavigate();

    const contentRef =
        useRef(null);

    const wrapperRef =
        useRef(null);

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");

    const [reloadKey, setReloadKey] =
        useState(0);

    const [fullscreen, setFullscreen] =
        useState(false);


    useEffect(() => {

        const onFullscreen =
            () =>
                setFullscreen(
                    Boolean(
                        document.fullscreenElement
                    )
                );

        document.addEventListener(
            "fullscreenchange",
            onFullscreen
        );

        return () =>
            document.removeEventListener(
                "fullscreenchange",
                onFullscreen
            );

    }, []);


    useEffect(() => {

        let alive =
            true;

        const load =
            async () => {

                try {

                    setLoading(true);
                    setError("");

                    const result =
                        await getDocxReaderBuffer(
                            slug
                        );

                    if (!alive) {
                        return;
                    }

                    const type =
                        String(
                            result.contentType ||
                            ""
                        ).toLowerCase();

                    if (
                        !type.includes(
                            "wordprocessingml"
                        ) &&
                        !type.includes(
                            "application/octet-stream"
                        )
                    ) {
                        throw new Error(
                            "File này không phải DOCX. Content-Type: " +
                            type
                        );
                    }

                    if (
                        !contentRef.current
                    ) {
                        return;
                    }

                    contentRef.current.innerHTML =
                        "";

                    await renderAsync(
                        result.data,
                        contentRef.current,
                        null,
                        {
                            className:
                                "docx",

                            inWrapper:
                                true,

                            breakPages:
                                true,

                            ignoreWidth:
                                false,

                            ignoreHeight:
                                false,

                            ignoreFonts:
                                false,

                            useBase64URL:
                                true
                        }
                    );


                    /*
                     * Chan hyperlink trong tai lieu
                     * de nut XEM NGAY khong day khach sang Drive.
                     */
                    const links =
                        contentRef.current
                            .querySelectorAll(
                                "a"
                            );

                    links.forEach(
                        link => {

                            link.removeAttribute(
                                "href"
                            );

                            link.removeAttribute(
                                "target"
                            );

                            link.style.pointerEvents =
                                "none";

                            link.style.cursor =
                                "default";
                        }
                    );

                    if (alive) {
                        setLoading(false);
                    }

                } catch (err) {

                    console.error(
                        "DOCX LAB ERROR:",
                        err
                    );

                    if (alive) {

                        setLoading(false);

                        setError(
                            err?.message ||
                            "Không thể mở DOCX."
                        );
                    }
                }
            };

        load();

        return () => {
            alive =
                false;
        };

    }, [
        slug,
        reloadKey
    ]);


    const toggleFullscreen =
        async () => {

            try {

                if (
                    document.fullscreenElement
                ) {
                    await document
                        .exitFullscreen();

                    return;
                }

                if (
                    wrapperRef.current
                        ?.requestFullscreen
                ) {
                    await wrapperRef
                        .current
                        .requestFullscreen();
                }

            } catch (err) {

                console.log(
                    "Fullscreen error:",
                    err
                );
            }
        };


    return (

        <div
            ref={wrapperRef}
            className="
                fixed
                inset-0
                z-[99999]
                flex
                flex-col
                bg-[#202124]
            "
        >

            <header
                className="
                    h-[58px]
                    flex-none
                    flex
                    items-center
                    gap-2
                    px-3
                    md:px-4
                    bg-[#17191c]
                    border-b
                    border-white/10
                    text-white
                "
            >

                <button
                    type="button"
                    onClick={() =>
                        navigate(-1)
                    }
                    className="
                        h-9
                        px-3
                        rounded-lg
                        flex
                        items-center
                        gap-2
                        hover:bg-white/10
                    "
                >
                    <ArrowLeftOutlined />

                    <span
                        className="
                            hidden
                            sm:inline
                            font-semibold
                            text-sm
                        "
                    >
                        THƯ VIỆN
                    </span>
                </button>


                <div
                    className="
                        flex-1
                        min-w-0
                    "
                >

                    <div
                        className="
                            truncate
                            font-semibold
                            text-sm
                            md:text-[15px]
                        "
                    >
                        {title ||
                            "Tài liệu"}
                    </div>

                    <div
                        className="
                            hidden
                            sm:block
                            text-[10px]
                            text-gray-400
                        "
                    >
                        Đang đọc trực tuyến
                    </div>

                </div>


                <button
                    type="button"
                    onClick={() =>
                        setReloadKey(
                            value =>
                                value + 1
                        )
                    }
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Tải lại"
                >
                    <ReloadOutlined />
                </button>


                <button
                    type="button"
                    onClick={
                        toggleFullscreen
                    }
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Toàn màn hình"
                >
                    {fullscreen
                        ? <CompressOutlined />
                        : <ExpandOutlined />
                    }
                </button>

            </header>


            <main
                className="
                    relative
                    flex-1
                    min-h-0
                    overflow-auto
                    bg-[#303030]
                    py-5
                    px-2
                    md:px-5
                "
            >

                {loading && (

                    <div
                        className="
                            fixed
                            inset-0
                            top-[58px]
                            z-20
                            flex
                            items-center
                            justify-center
                            bg-[#202124]
                            text-gray-300
                        "
                    >
                        Đang mở tài liệu DOCX...
                    </div>
                )}


                {error && (

                    <div
                        className="
                            mx-auto
                            mt-14
                            max-w-[560px]
                            rounded-xl
                            bg-white
                            p-6
                            shadow-xl
                        "
                    >

                        <div
                            className="
                                text-lg
                                font-semibold
                                text-red-600
                        "
                        >
                            Không mở được tài liệu
                        </div>

                        <div
                            className="
                                mt-3
                                text-sm
                                text-gray-600
                            "
                        >
                            {error}
                        </div>

                    </div>
                )}


                <div
                    ref={contentRef}
                    className="
                        os-docx-reader
                        mx-auto
                    "
                />

            </main>


            <style>
                {`
                .os-docx-reader .docx-wrapper {
                    background: transparent !important;
                    padding: 0 !important;
                }

                .os-docx-reader .docx-wrapper > section.docx {
                    margin: 0 auto 20px !important;
                    box-shadow:
                        0 8px 30px rgba(0,0,0,.32);
                }

                .os-docx-reader a {
                    pointer-events: none !important;
                    cursor: default !important;
                    text-decoration: none !important;
                    color: inherit !important;
                }
                `}
            </style>

        </div>
    );
}
